module.exports = __webpack_public_path__ + "static/img/455d937a19ce487ba74ea13d9a75a7c9.89d23ce9.png";